module.exports = __webpack_public_path__ + "fonts/Rubik/rubik-v28-arabic_cyrillic_cyrillic-ext_hebrew_latin_latin-ext-700.woff2";